import Picture1 from '../WelcomeWelcome/assets/welcome.jpg';
import Picture2 from '../WelcomeWelcome/assets/praxis.jpg';
import './ImageCarussel.css';

import React, { useState, useEffect } from 'react';

function ImageCarussel() {
    const [currentIndex, setCurrentIndex] = useState(0);
    const images = [
        <img key="Picture1" className={currentIndex === 0 ? "PictureVisible" : "PictureHidden"} src={Picture1} alt="Test" />,
    ];

    // useEffect(() => {
    //     const intervalId = setInterval(() => {
    //         setCurrentIndex((prevIndex) => (prevIndex + 1) % images.length);
    //     }, 7000);


    //     return () => {
    //         clearInterval(intervalId);
    //     };
    // }, []);

    return (
        <div className='ImageContainer'>                {images}
        </div>

    );
}

export default ImageCarussel;
